__webpack_require__.p = "/MarvelPortal/";